import PhoneInput from "react-phone-input-2";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import countries from "i18n-iso-countries";
import "react-phone-input-2/lib/bootstrap.css";

const getCountryCode = (value) => {
  if (!value) return "se";
  const trimmed = String(value).trim();
  if (/^[a-z]{2}$/i.test(trimmed)) {
    return trimmed.toLowerCase();
  }
  const code = countries.getAlpha2Code(trimmed, "en");
  return (code ? code : "SE").toLowerCase();
};

export const isValidPhone = (phoneDigits, countryCode) => {
  try {
    const parsed = parsePhoneNumberFromString("+" + String(phoneDigits || ""), countryCode.toUpperCase());
    return parsed?.isValid() ?? false;
  } catch {
    return false;
  }
};

const PhoneNumberInput = ({
  countryName,
  value,
  onChange,
  containerClass = "react-tel-input w-100 ui-phone",
  inputClass = "w-100 border-0 shadow-none bg-body text-body",
  buttonClass = "btn bg-body border-0",
  dropdownClass = "dropdown-menu show",
  disabled = false,
  name = "phone",
  autoComplete = "tel"
}) => {
  const countryCode = getCountryCode(countryName);
  const sanitized = String(value || "").replace(/^\+/, "");

  return (
    <PhoneInput
      country={countryCode}
      value={sanitized}
      onChange={(digits, countryData) => {
        const dialCode = String(countryData?.dialCode || "");
        const nationalNumber = digits.startsWith(dialCode) ? digits.slice(dialCode.length) : digits;
        onChange({
          phone: digits,
          dialCode,
          nationalNumber,
          isValid: isValidPhone(digits, countryCode),
        });
      }}
      onlyCountries={[countryCode]}
      disableDropdown
      countryCodeEditable={false}
      enableSearch={false}
      containerClass={containerClass}
      inputClass={inputClass}
      buttonClass={buttonClass}
      dropdownClass={dropdownClass}
      inputProps={{ name, autoComplete, disabled }}
    />
  );
};

export default PhoneNumberInput;
